import { AutoMap } from "@automapper/classes";
import { ETypeMaterielAdductionAir } from "./enum/type-materiel";
import { MaterielCompresseur } from "./materiel-compresseur";

export class MaterielAdduction {
    @AutoMap()
    Type!: ETypeMaterielAdductionAir;
    @AutoMap()
    Fabricant!: string;
    @AutoMap()
    Description!: string;
    @AutoMap()
    Reference!: string;
    @AutoMap()
    MaterielCompresseur: MaterielCompresseur = new MaterielCompresseur();
}